//
// LayoutConstraint.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../../moduleBuilder";
import EventDispatcher from "../../events/EventDispatcher";
import "../../lib";
import "../../models/BaseUIModel";
import "../../util/Dimension";
import "./FlexibilityType";
import "./PreferredSizeBehaviorType";
import "../LayoutProxy";

var LayoutConstraint = createModule("commons_LayoutConstraint", [130,13,10004,10046], EventDispatcher, [
    ,
    {
        singleChildMakesContainerHeightUnconstrained: 2,
        heightFlexibility: 4,
        usePreferredSizeAsMaximum: 2,
        horizontalOffset: 1,
        widthPreferredSizeBehavior: 4,
        borderThickness: 5,
        growPercentageContext: 1,
        heightPreferredSizeBehavior: 4,
        additionalContentHeight: 5,
        rightSpace: 5,
        leftSpace: 5,
        lockUserHeight: 2,
        maximumWidth: 5,
        additionalContentWidth: 5,
        responsiveWeights: [5],
        widthFlexibility: 4,
        height: 1,
        zIndex: 4,
        padding: 1,
        backupResponsiveWeights: [5],
        footerHeight: 5,
        growHorizontal: 2,
        tiledReflowMinimumHeight: 5,
        growVertical: 2,
        verticalOffset: 1,
        minimumHeight: 5,
        backupWidth: 1,
        backupHeightFlexibility: 4,
        considerChildrenForSizeCalculations: 2,
        singleChildMakesContainerWidthUnconstrained: 2,
        width: 1,
        lockUserWidth: 2,
        maximumHeight: 5,
        headerHeight: 5,
        minimumWidth: 5,
        useGroupDispatch: 2,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default LayoutConstraint;
